// FLAGS: identity
// The second-factor step: submits the six-digit authenticator code that upgrades the session.
import { toast } from "sonner";
import { useTotpMutation } from "@src/queries/auth";
import CodeInput from "@src/pages/login/CodeInput";

interface TotpStepProps {
  onBack: () => void;
}

// FLAGS: identity
// A rejected code only raises a toast and re-enables the field. There is no attempt limit on this
// screen, so whatever limit exists is the API's — do not add UI that implies one is enforced here.
const TotpStep = ({ onBack }: TotpStepProps) => {
  const totpMutation = useTotpMutation();

  const onSubmit = (code: string) => {
    totpMutation.mutate(code, {
      onError: () => toast.error("Invalid verification code. Try again."),
    });
  };

  return (
    <div className="flex flex-col items-center gap-6">
      <p className="text-center text-gray-600">
        Enter the 6-digit code from your authenticator app.
      </p>
      <CodeInput
        onSubmit={onSubmit}
        busy={totpMutation.isPending}
        error={totpMutation.isError}
      />
      <button
        type="button"
        onClick={onBack}
        className="text-sm font-medium text-green-700 hover:text-green-900"
      >
        Back to Google sign-in
      </button>
    </div>
  );
};

export default TotpStep;
